export default __webpack_public_path__ + "static/media/I_GLOBAL.1657a6bf.png";